<template>
    <div ref="container">
        <div class="record" v-for="(item,index) in productList" :key="index">
            <div class="name">{{item.nickname}} {{item.phone}}</div>
            <div class="time">{{item.spread_time_date}}</div>
        </div>
        <div class="no-show" v-if="productList.length==0 && loading">
            <img src="../../assets/newImg/no_show.png" alt="" />
        </div>
        <div class="loading-more" v-if="loadend">暂无更多了</div>
    </div>
</template>
<style lang="scss" scoped>
.record {
    margin: 11px 10px 0 10px;
    background: #ffffff;
    border-radius: 10px;
    padding-left: 18px;
    height: 78px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    .name {
        color: #333;
        font-size: 16px;
        font-weight: 600;
    }
    .time {
        font-size: 14px;
        padding-top: 13px;
    }
}
</style>
<script>
import { recordList} from '@api/user';
export default {
    name: "recordFriends",
    data() {
        return {
            loading: false,
            loadend: false,
            page: 1,
            limit: 10,
            productList:[]
        };
    },
    methods: {
        get_product_list() {
            var that = this;
            if (that.loading) return;
            if (that.loadend) return;
            that.loading = true;
            recordList({
                page: that.page,
                limit: that.limit,
            }).then((res) => {
                that.loading = false;
                that.productList.push.apply(that.productList, res.data.my_company_list_info);
                that.loadend = res.data.my_company_list_info.length < that.limit;
                that.page = that.page + 1;
            });
        },
    },
    mounted() {
        this.get_product_list();
        this.$scroll(this.$refs.container, () => {
            !this.loading && this.get_product_list();
        });
    },
};
</script>
